import React from 'react';
import { Link } from 'react-router-dom';
import { Heading, Text } from './Typography';
// Import css from NewLandingPage to keep styles consistent (or move to tokens/global if preferred)
import '../../../pages/Home/Home.css';
import './Footer.css';

// Import images
import logo_heart from '../../../assets/images/heart-logo.png';
import youtube from '../../../assets/images/youtube.png';
import tiktok from '../../../assets/images/tiktok.png';
import gram from '../../../assets/images/gram.png';

export const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-grid">
                {/* Description Column */}
                <div className="lp-space-y-6 lp-col-span-2 lp-md-col-span-1" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                            <Link to="/" className="flex items-center gap-2" style={{ textDecoration: 'none' }}>
                                <img src={logo_heart} alt="MTD Logo" className="nav-logo" />
                                <span className="lp-font-black lp-text-xl lp-tracking-tight" style={{ color: '#111111' }}>myTamilDate</span>
                            </Link>
                        </div>
                    </div>
                    <Text size="sm" className="lp-text-gray-500" style={{ maxWidth: '400px', textDecoration: 'none' }}>
                        myTamilDate (MTD) is a leading dating community for the global Tamil diaspora. Join today to find your special someone!
                    </Text>
                </div>

                {/* Explore Column */}
                <div>
                    <Heading variant="h4" className="lp-text-lg lp-font-black lp-tracking-tight lp-mb-4" style={{ marginBottom: '1rem' }}>Explore</Heading>
                    <ul className="footer-links">
                        <li><Link to="/SuccessPage" className="footer-link">Success Stories</Link></li>
                        <li><a href="https://tamilculture.com/user/mytamildatecom" target="_blank" rel="noopener noreferrer" className="footer-link">Blogs</a></li>
                        <li><Link to="/aboutus" className="footer-link">About Us</Link></li>
                        <li><Link to="/GetInTouch" className="footer-link">Contact Us</Link></li>
                    </ul>
                </div>

                {/* Support Column */}
                <div>
                    <Heading variant="h4" className="lp-text-lg lp-font-black lp-tracking-tight lp-mb-4" style={{ marginBottom: '1rem' }}>Support</Heading>
                    <ul className="footer-links">
                        <li><Link to="/FaqPage" className="footer-link">FAQs</Link></li>
                        <li><Link to="/Tnc" className="footer-link">Terms & Conditions</Link></li>
                        <li><Link to="/PrivacyPolicy" className="footer-link">Privacy Policy</Link></li>
                    </ul>
                </div>

                {/* Connect Column */}
                <div className="lp-col-span-2 lp-md-col-span-1">
                    <Heading variant="h4" className="lp-font-bold lp-mb-6" style={{ marginBottom: '1rem' }}>Connect with us!</Heading>
                    <div className="flex gap-4" style={{ display: 'flex', gap: '1.5rem' }}>
                        <a href="http://www.youtube.com/@mytamildate1279" target="_blank" rel="noopener noreferrer">
                            <img src={youtube} alt="YouTube" style={{ width: '40px', height: '40px' }} />
                        </a>
                        <a href="https://www.instagram.com/mytamildate/" target="_blank" rel="noopener noreferrer">
                            <img src={gram} alt="Instagram" style={{ width: '40px', height: '40px' }} />
                        </a>
                        <a href="https://www.tiktok.com/@mytamildate?lang=en" target="_blank" rel="noopener noreferrer">
                            <img src={tiktok} alt="TikTok" style={{ width: '40px', height: '40px' }} />
                        </a>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto lp-pt-6 lp-mt-6 border-t border-gray-100 lp-text-center lp-text-xs lp-text-gray-400" style={{ borderTop: '1px solid #f3f4f6', textAlign: 'center' }}>
                © 2024 myTamilDate | All Rights Reserved
            </div>
        </footer>
    );
};
